<template>
  <transition name="modal" appear>
    <div class="modal modal-overlay" @click.self="$emit('close')">
      <div class="modal-window" v-bind:class="size">
        <div class="modal-content">
          <slot/>
        </div>
      </div>
    </div>
  </transition>
</template>

<script lang='ts'>
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default {
  components: {
    disableBodyScroll,
    enableBodyScroll,
    clearAllBodyScrollLocks,
  },
  props: {
    size: {
      type: String,
      default: 'logout',
      required: true,
    },
  },
  mounted() {
    const modal = document.querySelector('.modal');
    disableBodyScroll(modal);
  },
  beforeDestroy() {
    clearAllBodyScrollLocks();
  },
};
</script>

<style lang="scss" scoped>
@import "../style/variables.scss";

.modal {
  &.modal-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 10000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.64);
    overflow: hidden;
  }
  &-window {
    background: $main_color;
    border-radius: 4px;
    // 各モーダル画面のサイズ設定
    // 念のため同一サイズであっても画面ごとの設定値を用意しておく
    &.logout {
      width: 300px;
      height: 230px;
      overflow: hidden;
    }
    &.delete {
      width: 580px;
      height: 300px;
      overflow: hidden;
    }
    &.resignation {
      width: 580px;
      height: 380px;
      overflow: hidden;
    }
    &.branchChange {
      width: 650px;
      height: 350px;
      overflow: hidden;
    }
    &.notification {
      width: 650px;
      height: 750px;
      overflow: hidden;
    }
    &.site {
      width: 650px;
      height: 450px;
      overflow: hidden;
    }
    &.worker {
      width: 1050px;
      height: 800px;
      overflow: auto;
      overflow-y: scroll;
    }
    &.business {
      width: 1050px;
      height: 800px;
      overflow: auto;
      overflow-y: scroll;
    }
    &.loginId {
      width: 600px;
      height: 500px;
      overflow: hidden;
    }
    &.ccusId {
      width: 600px;
      height: 700px;
      overflow: hidden;
    }
    // 転入手続き
    &.moveIn {
      width: 700px;
      height: 600px;
      overflow: hidden;
    }
    &.accountMoveIn {
      width: 700px;
      height: 450px;
      overflow: hidden;
    }
    &.deleteCompanySites {
      width: 580px;
      height: 700px;
      overflow: hidden;
    }
  }
  &-content {
    text-align: center;
  }
}

</style>
